module.exports = __webpack_public_path__ + "img/12.3f7a751a.png";